export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^(([14][0-8])|([28][02-9])|(3[0-35689])|(5[1-35-9])|(6[02-7])|(7[0-69])|(9[0-7]))[0-9]{4}$/i));
    }
}
